'<template>
  <div>
    <div v-if="!ready" class="loader"></div>
    <div v-else id="app" :class="{ [step]: true }">
      <!-- splash -->
      <div
        v-if="step === 'poster'"
        class="splash z3 flex justify-center items-center"
        :class="{
          'bg-white': ['2', 'all'].includes(query.p) || bg === 'white',
        }"
        @click="step = 'list'"
      >
        <div class="relative">
          <img :src="poster" alt="poster" />
          <button class="start-btn">
            <span class="button-inner">
              <p>เริ่มสั่งอาหาร</p>
            </span>
          </button>
        </div>
      </div>
      <!-- restaurant-container -->
      <div
        :class="{
          hide: step !== 'list',
        }"
        class="navbar flex justify-start items-center fixed top-0 left-0 right-0 bg-white z2"
      >
        <img
          v-if="district === 'thai' || district === 'music'"
          class="logo featured-img english"
          src="data:image/png;base64,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"
        />
        <img
          v-else-if="!useFeaturedImg"
          class="logo featured-img not-featured"
          src="data:image/png;base64,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"
        />
        <img
          v-else
          class="logo featured-img"
          src="https://res.cloudinary.com/dimorder/image/upload/v1605091575/Group_52_fy8zno.png"
        />
        <!-- <span v-if="table">หมายเลขโต๊ะ: {{ table }}</span> -->
      </div>
      <section
        :class="{
          hide: step !== 'list',
        }"
        class="restaurant-container"
      >
        <span></span>
        <ul class="vendor-list">
          <li v-for="(restaurant, i) of restaurants" :key="i">
            <a @click="restaurantOnClick(restaurant)">
              <figure class="vendor-tile item">
                <picture>
                  <div
                    class="vendor-picture"
                    :style="{
                      backgroundImage: `url(&quot;${restaurant.img}&quot;)`,
                    }"
                  ></div>
                </picture>
                <figcaption class="vendor-info">
                  <span class="headline">
                    <span class="name fn">{{ restaurant.name }}</span>
                  </span>
                </figcaption>
              </figure>
            </a>
          </li>
        </ul>
      </section>

      <div v-if="modalIsOpen" class="modal">
        <div class="mask"></div>
        <div class="wrap" @click.self="modalIsOpen = false">
          <div class="modal-card">
            <div class="modal-content">
              <div class="modal-header">
                <div class="modal-title">{{ merchant.name }}</div>
              </div>
              <div class="modal-body">
                <div
                  style="min-height: 250px; max-height: 646px; overflow: scroll"
                >
                  <img :src="merchant.img" width="100%" alt />
                </div>
              </div>
              <div class="modal-footer">
                <div
                  class="modal-button-group-v modal-button-group-normal"
                  role="group"
                >
                  <a
                    class="modal-button"
                    role="button"
                    target="_blank"
                    v-for="button in merchant.buttons[source]"
                    :key="button.label"
                    @click="openLink(button.url)"
                    >{{ button.label }}</a
                  >
                  <a
                    class="modal-button"
                    role="button"
                    @click.self="modalIsOpen = false"
                    >กลับ</a
                  >
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import axios from "axios";
const sourceMap = {
  w: "wifinity",
  l: "leaflet",
  p: "poster",
  t: "tissue",
  f: "facebook",
  i: "instagram",
  r1: "referral1",
  r2: "referral2",
  r3: "referral3",
  r4: "referral4",
  r5: "referral5",
};
/**
 * Adds a query parameter to the given URL.
 *
 * @param {string} url - The URL to modify.
 * @param {string} key - The key of the query parameter to add.
 * @param {string} value - The value of the query parameter to add.
 * @returns {string} - The modified URL with the query parameter added.
 */
function addQueryParamToUrl(url, key, value) {
  const separator = url.includes("?") ? "&" : "?";
  const param = `${key}=${value}`;
  return `${url}${separator}${param}`;
}
function getValidButtons(buttons) {
  return buttons.filter((b) => b.label && b.url);
}

export default {
  name: "App",
  data() {
    return {
      bg: "",
      ready: false,
      step: "poster", // list
      modalIsOpen: false,
      list: [],
      merchant: {},
      restaurants: [],
      query: {},
      useFeaturedImg: false,
      table: "",
      district: "",

      source: "default",
      poster: "",
      defaultPoster:
        "https://res.cloudinary.com/order/image/upload/c_scale,w_576/v1582321997/Coronavirus_Poster_2_-1_qbiwvi.jpg",
    };
  },
  components: {},
  async created() {
    // https://list.dimorder.com?w=1&d=wc&u=medic
    // query param explain:
    // s=, source, means the source enter this page, eg: instagram, facebook
    // p=, poster, means use which poster. refer to sheet - Background
    // d=, district, means district, refer to sheet - District, Directory
    // t=, table number, pass this parameter to button click url

    const query = this.getQueryObject();
    const district = this.getDistrict();
    this.district = district;
    const poster = this.getPoster();

    if (district === "all") {
      this.useFeaturedImg = true;
    }

    this.query = query;
    this.source = sourceMap[query.s] ? sourceMap[query.s] : "default";
    // call api
    const r = await axios.get(
      "https://demo-sheet.dimorder.com?" + `d=${district}&p=${poster}`
    );
    this.ready = true;
    this.poster = r.data.poster || this.defaultPoster;
    this.bg = r.data.bg;
    this.restaurants = r.data.restaurants.filter(
      (restaurant) =>
        restaurant.buttons[this.source].filter((o) => o.label).length
    );
    this.table = query.t;

    console.log("district", this.district);
    console.log("poster", this.poster);
    if (
      this.poster ===
      "https://res.cloudinary.com/dimorder/image/upload/w_414/v1609295214/email/WhatsApp_Image_2020-12-30_at_10.26.10_AM_irerqf.jpg"
    ) {
      this.step = "list";
    }
    setTimeout(() => {
      this.step = "list";
    }, 2500);
  },
  methods: {
    getPoster() {
      const query = this.getQueryObject();
      let p = query.p;
      if (!p && window.location.host.match(/^rest\./)) {
        p = "all";
      }
      return p;
    },
    getDistrict() {
      const query = this.getQueryObject();
      let district = "wc";
      if (window.location.host.match(/^(rest|beta-rest)\./)) {
        district = "all";
      }
      if (query.d) {
        district = query.d;
      }
      return district;
    },
    restaurantOnClick(restaurant) {
      this.openModal(restaurant);
      const buttons = getValidButtons(restaurant.buttons[this.source]);
      if (buttons.length === 1) {
        this.openLink(buttons[0].url);
      } else {
        this.openModal(this.merchant);
      }
    },
    openModal(v) {
      this.modalIsOpen = true;
      this.merchant = v;
    },
    openLink(url) {
      const query = this.getQueryObject();
      if (query.t) {
        url = addQueryParamToUrl(url, "t", query.t);
      }
      window.open(url);
    },
    getQueryObject() {
      let uri = window.location.search.substring(1);
      let params = new URLSearchParams(uri);
      const entries = params.entries(); //returns an iterator of decoded [key,value] tuples
      let result = {};
      for (let entry of entries) {
        // each 'entry' is a [key, value] tupple
        const [key, value] = entry;
        result[key] = value;
      }
      return result;
    },
  },
  watch: {
    modalIsOpen: function (val) {
      if (val) {
        document.body.classList.add("overflow-hidden");
      } else {
        document.body.classList.remove("overflow-hidden");
      }
    },
  },
};
</script>

<style lang="scss">
@import "basscss";

$bg: #f2b924;

* {
  -webkit-tap-highlight-color: rgba(0, 0, 0, 0);
}
.bg-white {
  background-color: white !important;
}
.o0 {
  opacity: 0;
}

.hide {
  position: fixed;
  top: -200vh;
}

body {
  margin: 0;
}
img {
  max-width: 100%;
}
svg {
  max-height: 100%;
}

html,
body {
  touch-action: manipulation;
  height: 100%;
}

#app {
  position: relative;
  &.list {
    @media only screen and (min-width: 768px) {
      max-width: 400px;
      margin: 0 auto;
    }
  }
  min-height: 100%;
  font-family: Avenir, Helvetica, Arial, sans-serif;
  text-align: center;
  color: #2c3e50;
  background-color: #f5f5f9;
  @keyframes flash {
    50% {
      opacity: 0;
    }
  }

  .splash {
    cursor: pointer;
    width: 100vw;
    height: 100vh;
    background-color: #f2b924;
    &.bg-white {
      background-color: #fff;
    }
    .start-btn {
      appearance: none;
      animation: flash 2s infinite;
      // padding: 10vw 0;
      border-color: transparent;
      background-color: transparent;
      position: fixed;
      bottom: 20%;
      left: 0;
      width: 100%;
      font-size: 8vw;
    }
  }

  .navbar {
    @media only screen and (min-width: 768px) {
      max-width: 400px;
      margin: 0 auto;
    }
    user-select: none;
    color: #614d4a;
    height: 47px;
    .logo {
      width: 65px;
      margin-right: 10px;
      &.featured-img {
        width: 160px;
      }
    }
  }
  .restaurant-container {
    padding: 0 24px;
    padding-top: 79px;
    ul.vendor-list {
      display: flex;
      flex-wrap: wrap;
      margin: 0 -8px -8px;
      padding: 0;
      list-style-type: none;
      a {
        cursor: pointer;
        text-decoration: none;
      }
      > li {
        // mobile
        max-width: calc(50% - 16px);
        width: calc(50% - 16px);

        margin: 0 8px 40px;
        flex: 1 1 auto;
        position: relative;
        list-style: none;
        figure.vendor-tile {
          // min-height: 200px;
          position: relative;
          margin: 0;
          z-index: 0;
          picture {
            position: relative;
            display: block;
            height: 120px;
            overflow: hidden;
            .vendor-picture {
              background: no-repeat center;
              background-size: contain;
              display: block;
              height: 100%;
              position: relative;
              z-index: 1;
              transition: transform 300ms cubic-bezier(0.25, 0.46, 0.45, 0.94),
                opacity 150ms cubic-bezier(0.25, 0.46, 0.45, 0.94);
            }
          }
          .vendor-info {
            display: block;
            padding: 8px 0 0;
            color: #707070;
            font-size: 1.4rem;
            position: relative;
            z-index: 2;
            .headline {
              display: flex;
              flex-flow: row nowrap;
              .name {
                text-align: center;
                flex: 1 1 auto;
                display: inline-block;
                max-width: 100%;
                overflow: hidden;
                text-overflow: ellipsis;
                white-space: nowrap;
                word-wrap: normal;
                display: block;
                margin: 0;
                line-height: 1.3em;
                color: #333;
                font-size: 1rem;
                font-weight: normal;
                padding: 4px 0 0 0;
              }
            }
          }
        }
      }
    }
  }

  .modal {
    .mask {
      position: fixed;
      top: 0;
      right: 0;
      left: 0;
      bottom: 0;
      height: 100%;
      z-index: 999;
      background-color: rgba(0, 0, 0, 0.4);
    }
    .wrap {
      position: fixed;
      overflow: auto;
      top: 0;
      right: 0;
      bottom: 0;
      left: 0;
      height: 100%;
      z-index: 999;
      -webkit-overflow-scrolling: touch;
      outline: 0;
      display: -ms-flexbox;
      display: flex;
      -ms-flex-align: center;
      align-items: center;
      -ms-flex-pack: center;
      justify-content: center;
      -webkit-transform: translateZ(1px);
      transform: translateZ(1px);
      .modal-card {
        @media only screen and (min-width: 768px) {
          max-width: 400px;
        }
        width: 90% !important;
        .modal-content {
          border-radius: 7px;
          padding-top: 15px;
          position: relative;
          background-color: #fff;
          border: 0;
          background-clip: padding-box;
          text-align: center;
          height: 100%;
          overflow: hidden;
          .modal-header {
            padding: 6px 15px 15px;
          }
          .modal-body {
            padding: 0 15px 15px;
          }
          .modal-button {
            -webkit-touch-callout: none;
            position: relative;
            border-top: 1px solid #ddd;
            -webkit-box-sizing: border-box;
            box-sizing: border-box;
            text-align: center;
            text-decoration: none;
            outline: none;
            color: #108ee9;
            font-size: 18px;
            height: 50px;
            line-height: 50px;
            display: block;
            width: auto;
            overflow: hidden;
            -o-text-overflow: ellipsis;
            text-overflow: ellipsis;
            white-space: nowrap;
            &:active {
              background: #ddd;
            }
          }
        }
      }
    }
  }
}

.loader {
  position: fixed;
  top: 50%;
  left: 50%;
  margin-top: -55px;
  margin-left: -15px;
  border: 5px solid #f3f3f3;
  border-top: 5px solid $bg;
  border-radius: 50%;
  width: 30px;
  height: 30px;
  animation: spin 2s linear infinite;
}

@keyframes spin {
  0% {
    transform: rotate(0deg);
  }
  100% {
    transform: rotate(360deg);
  }
}
</style>